"use client";
import { observer } from "mobx-react";
import cn from "clsx";
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from "@/components/UKLoadingIcon";
import styles from "./index.module.scss";
import { useTranslation } from "@/i18n/client";

interface UKPageLoadingProps {
  loading?: boolean;
  text?: string;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  type?: "row" | "column";
}

const UKPageLoading: React.FC<UKPageLoadingProps> = observer((props: UKPageLoadingProps) => {
  const { t } = useTranslation() 
  const { 
    loading = true,
    text, 
    style, 
    className, 
    children,
    type = 'column'
  } = props;
  return (
    <>
      {!loading ? (
        children
      ) : (
        <div className={cn(styles.pageLoading, className)} style={style}>
          <div className={styles.pageLoadingContent} style={{ flexFlow: type }}>
            <UKLoadingIcon type={CIRCLE_COLOR_MAP.BLACK} />
            {text && <div className={styles.text}>{text}</div>}
          </div>
        </div>
      )}
    </>
  );
});

export default UKPageLoading;
